import { browserLogger } from 'src/utils/browser-logger'

export const copyTo = (text: string): Promise<void> => {
  if (navigator.clipboard != null) {
    return navigator.clipboard.writeText(text)
  }

  // this is a fallback for non-secure domains
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed' // avoid scrolling to bottom
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (err) {
    browserLogger.error('failed to write to clipboard', err)
  }

  document.body.removeChild(textArea)
  return Promise.resolve()
}
